import { FC, useEffect } from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectIsEnterpriseUser } from '../../../../../selectors/user';
import PaperModalV2 from 'raydiant-elements/core/PaperModalV2';
import Text from '@raydiant/raydial/components/Text';
import Select, { SelectItem } from '@raydiant/raydial/components/Select';
import { DEFAULT_QUERY } from '../../../../AddContentPage/AddContentPageV2';
import MoveContentTree from './MoveContentTree';

interface FolderState {
  [key: string]: boolean;
}

interface LibraryFolder {
  [key: string]: FolderState;
}

export interface MoveContentProps {
  disabledFolderIds: string[];
  onMove: (folderId: string) => void;
}

const MoveContent: FC<MoveContentProps> = ({ disabledFolderIds, onMove }) => {
  // Selectors
  const [libraryFolder, setLibraryFolder] = useState<LibraryFolder>({
    owned: {
      '': true,
    },
  });
  const [scope, setScope] = useState('owned');
  const [selectedProfileId, setSelectedProfileId] = useState<string>('');
  const [query, setQuery] = useState(DEFAULT_QUERY);

  const isEnterpriseUser = useSelector(selectIsEnterpriseUser);

  useEffect(() => {
    setSelectedProfileId('');
  }, []);

  // API hooks

  const toggleFolder = (folderId: string) => {
    let nextFolder: LibraryFolder;

    const groupKey = scope === 'users' ? selectedProfileId : scope;
    const selectedGroup = libraryFolder?.[groupKey] || {};
    const selectedFolderId = folderId;

    nextFolder = {
      ...libraryFolder,
      [groupKey]: {
        ...selectedGroup,
        [selectedFolderId]: !selectedGroup[selectedFolderId] || false,
      },
    };

    setLibraryFolder(nextFolder);
  };

  const handleQueryChange = (key: string) => {
    setSelectedProfileId('');
    if (key === 'owned') {
      setQuery({ ...query, scope: 'owned', profile_id: '' });
    }
    setScope(key);
  };

  // Render

  const renderPlaylistSelectorV2 = () => {
    return (
      <PaperModalV2.Body className="flex flex-col mb-4 gap-4 h-full">
        <div>
          <Text variant="subheader" className="text-black mb-1 flex">
            Select Folder
          </Text>
        </div>
        <div>
          <Select
            label="Library"
            className="w-full"
            isDisabled={!isEnterpriseUser}
            selectedKey={scope}
            onSelectionChange={(e) => handleQueryChange(e as string)}
          >
            <SelectItem id="owned">My Library</SelectItem>
          </Select>
        </div>
        <div className="flex flex-col flex-1 overflow-auto">
          <MoveContentTree
            openedFolders={libraryFolder[scope] || {}}
            onMove={onMove}
            onFolderClick={toggleFolder}
            scope={scope}
            profileId=""
            folderId=""
            isRootFolder
            disabledFolderIds={disabledFolderIds}
          />
        </div>
      </PaperModalV2.Body>
    );
  };

  return <>{renderPlaylistSelectorV2()}</>;
};

export default MoveContent;
